// Manually tracked navigation trail, used by BackLinkComponent (back_controller.js) instead of
// document.referrer, which can be blocked by privacy settings or mobile app WebViews.
//
// Entries are pages LEFT via a regular (non-back) link click — pushed in navigation_memory_controller.js
// right before navigating away. peekTarget/popStack are separate so an invalid target is left in
// place instead of consumed.
const KEY = 'navigationHistory'
const MAX_ENTRIES = 10

export function pushPath(path) {
  const stack = getStack().filter((p) => p !== path)
  stack.push(path)
  setStack(stack.slice(-MAX_ENTRIES))
}

export function peekTarget() {
  const stack = getStack()
  return stack.length ? stack[stack.length - 1] : null
}

export function popStack() {
  const stack = getStack()
  stack.pop()
  setStack(stack)
}

// An entry equal to the current page is dead weight (e.g. a form submit's redirect, or revisiting
// an already-tracked page via a plain link, never goes through pushPath to clear it) — strip it,
// wherever it sits in the trail.
export function dropStaleEntries(currentPath) {
  const stack = getStack()
  const cleaned = stack.filter((entry) => new URL(entry, window.location.origin).pathname !== currentPath)
  if (cleaned.length !== stack.length) {
    setStack(cleaned)
  }
}

// A page with neither BackLinkComponent nor CancelLinkComponent (data-back-navigable) is a
// root/index view nothing ever links back from — reset the trail so it doesn't carry stale entries
// into an unrelated later flow.
export function resetIfNoBackTarget() {
  if (!document.querySelector('[data-back-navigable]')) {
    setStack([])
  }
}

function getStack() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '[]')
  } catch {
    return []
  }
}

function setStack(stack) {
  sessionStorage.setItem(KEY, JSON.stringify(stack))
}
